var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/ledger-account-category'], function($, core, BaseCollection, LedgerAccountCategoryModel) {
  var LedgerAccountCategoryCollection;
  return LedgerAccountCategoryCollection = (function(_super) {

    __extends(LedgerAccountCategoryCollection, _super);

    function LedgerAccountCategoryCollection() {
      LedgerAccountCategoryCollection.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountCategoryCollection.prototype.path = core.getConfig().apiPrefix + 'ledgeraccountcategory.json';

    LedgerAccountCategoryCollection.prototype.model = LedgerAccountCategoryModel;

    LedgerAccountCategoryCollection.prototype.filteredByFlags = function() {
      var categories, categoryRules, featureFlags;
      categories = this.toJSON();
      featureFlags = core.getFeatureFlags();
      categoryRules = {
        '8': 'cogs'
      };
      return categories.filter(function(category) {
        return featureFlags[categoryRules[category.id]] !== false;
      });
    };

    return LedgerAccountCategoryCollection;

  })(BaseCollection);
});
